<div class="cams-apply-search" [ngClass]="{'cams-drawer': !isModal}">
    <div mat-dialog-title class="title d-flex align-items-center justify-content-space-between py-4 bg-gray"
        *ngIf="isModal">
        <h4 class="mb-0 w-100">Search CAMS</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close(false)"><i
                class="flaticon-close"></i></button>
    </div>

    <div class="title d-flex align-items-center justify-content-space-between bg-gray py-4" *ngIf="!isModal">
        <h4 class="mb-0 py-4 px-4 fs-18">Search CAMS</h4>
    </div>

    <form [ngClass]="{'p-0': !isModal}" [formGroup]="cams_search_form" (ngSubmit)="search()">
        <mat-dialog-content>
            <mat-card class="tagus-card add-user-wrapper">
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="form-label">
                                    CAMS ID
                                </mat-label>
                                <input matInput class="form-control" formControlName="applicationId" />
                            </mat-form-field>
                        </div>

                        <div class="col-lg-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="form-label">
                                    Student Name
                                </mat-label>
                                <input matInput class="form-control" formControlName="studentName" />
                            </mat-form-field>
                        </div>

                        <div class="col-lg-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="form-label">
                                    Student ID
                                </mat-label>
                                <input matInput class="form-control" formControlName="studentId" />
                            </mat-form-field>
                        </div>

                        <div class="col-md-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="form-label">
                                    University
                                </mat-label>
                                <mat-select class="form-control" formControlName="universityId" msInfiniteScroll
                                    (infiniteScroll)="getNextUniversity()"
                                    [complete]="university_offset === total_university_count">
                                    <mat-option>
                                        <ngx-mat-select-search [formControl]="university_filter"
                                            placeholderLabel="Find name..."
                                            noEntriesFoundLabel="'No matching name found'"
                                            [clearSearchInput]="search_entiry.clear_search_input">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let university of university" [value]="university.id">
                                        {{university.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label class="form-label">
                                    Student Email ID
                                </mat-label>
                                <input matInput class="form-control" formControlName="studentEmailId" />
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </mat-dialog-content>
        <mat-dialog-actions class="border-t-1" align="end">
            <div class="text-end {{!isModal ? 'px-4' : 'p-0'}}">
                <button type="button" class="me-10" mat-flat-button color="warn" (click)="close(false)" *ngIf="isModal">
                    <i class="ri-close-fill"></i> Cancel
                </button>
                <ng-container>
                    <button type="submit" mat-flat-button color="primary" *ngIf="showAssignButton"
                        class="{{!isModal ? 'w-100' : ''}}">
                        <i class="ri-search-line"></i> Search
                    </button>

                    <button type="button" mat-button color="warn" *ngIf="!isModal" class="{{!isModal ? 'w-100' : ''}}"
                        (click)="resetForm()">
                        <i class="ri-delete-bin-line"></i> Reset Form
                    </button>
                </ng-container>
            </div>
        </mat-dialog-actions>
    </form>
</div>